<footer class="footer-bar">
  &copy; {{year}} {{copyrightName}}
</footer>

<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" [baseZIndex]="9999999999999" maskStyleClass="ui-dialog-mask ui-widget-overlay ui-dialog-visible ui-dialog-mask-scrollblocker"></p-confirmDialog>

<!-- Specifically used for the BasePage Warning Dialog in WarpEntityLogService -->
<p-confirmDialog class="basepage-dialog" key="basepage-dialog" [baseZIndex]="99999999999999"></p-confirmDialog>
